exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".user-show .profile-username[data-v-2377bcb0] {\n  font-size: 40px;\n}\n.user-show .profile-username span[data-v-2377bcb0] {\n  font-size: 21px;\n  color: #919191;\n}\n#disabledBlockWrap[data-v-2377bcb0] {\n  position: relative;\n}\n#disabledBlockWrap #disabledBlock.disabled[data-v-2377bcb0] {\n  opacity: 0;\n  pointer-events: none;\n}\n#disabledBlockWrap .spinner-center[data-v-2377bcb0] {\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  display: none;\n  font-size: 40px;\n}\n#disabledBlockWrap .cursor-pointer[data-v-2377bcb0] {\n  cursor: pointer;\n}", ""]);

// exports
